var React = require('react');

function DollyFlatbedEmpty (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M162.74 448a48 48 0 1 0 90.52 0zm378.52 0h-90.52a48 48 0 1 0 90.52 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640 400v32a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V64H16A16 16 0 0 1 0 48V16A16 16 0 0 1 16 0h96a16 16 0 0 1 16 16v368h496a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

DollyFlatbedEmpty.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = DollyFlatbedEmpty;

DollyFlatbedEmpty.default = DollyFlatbedEmpty;
